import { render, staticRenderFns } from "./colls.vue?vue&type=template&id=30735a21&scoped=true"
import script from "./colls.vue?vue&type=script&lang=js"
export * from "./colls.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=30735a21&prod&scoped=true&lang=css&external"
import style1 from "./colls.vue?vue&type=style&index=1&id=30735a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30735a21",
  null
  
)

export default component.exports